
import { trigger } from '../../dom/modules/trigger.js';
import events from '../../dom/modules/events.js';

events({ type: 'click', select: '.search-block > [type="reset"]' }, document.body)
.map((e) => e.target.closest('[data-popable]'))
.each((popable) => trigger('dom-deactivate', popable));

/* click to submit? */
/*
events({ type: 'click', select: '.search-block > a.icon-thumb' }, document.body)
.map((e) => e.target.closest('[data-popable]'))
.each((form) => {
    if (form && form.classList.contains('active')) {
        form.submit();
    }
});
*/

/* Attempt to stop the page from jumping around due to scroll-padding-top, on
   focus and while typing */
events({ type: 'focusin', select: '#search-input' }, document.body)
.each((e) => {
    document.documentElement.style = 'scroll-padding-top: 0px;';
});

events({ type: 'focusout', select: '#search-input' }, document.body)
.each((e) => {
    document.documentElement.style = '';
});
